import React, {useContext} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import {ViewModelForm, useDataRefresh, ViewModelServiceContext} from '@xengage/gw-portals-viewmodel-react';

import metadata from './MLPolicyChangesAdditionalFilter.metadata.json5';
import messages from './MLPolicyChangesAdditionalFilter.messages';

const MLPolicyChangesAdditionalFilter = (props) => {
    const {
        filterData,
        updateFilterData
    } = props;
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const changeInitiatorTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('Initiator_ML').codes;

    const getChangeInitiatorsAvailVal = () => {

        return changeInitiatorTypeList.map((chgInit) => ({
            code: chgInit.code,
            name: translator({
                id: chgInit.name,
                defaultMessage: chgInit.name
            })
        }));
    }

    const onValueChange = (value, path) => {
        _.set(filterData, path, value);
        updateFilterData(filterData);
        refreshData();
    }

    const overrideProps = {
        changeInitiators: {
            availableValues: getChangeInitiatorsAvailVal()
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={filterData}
            onValueChange={onValueChange}
        />
    );
};

MLPolicyChangesAdditionalFilter.propTypes = {
    filterData: PropTypes.shape({}).isRequired,
    updateFilterData: PropTypes.func.isRequired,
    assignedByValues: PropTypes.array.isRequired,
    prioritiesTypelist: PropTypes.array.isRequired,
};

export default MLPolicyChangesAdditionalFilter;